<template>
  <StandardCardPageContainer>
    <div v-if="showUserSearch">
      <h1 class="mb-8">Find user</h1>
      <v-row>
        <v-col cols="12" sm="6">
          <PInputField
            :value="email"
            label="Email"
            @update-event="(val) => (email = val)"
          />
          <PPrimaryButton class="mr-3 mb-6" @click="checkUserExists">
            Find user
          </PPrimaryButton>
        </v-col>
      </v-row>
    </div>
    <UserDisplay v-else :email="email" @exit="resetForm" />
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { ref } from "vue";
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import UserDisplay from "@/views/admin-view/UserDisplay.vue";
import { UserProfile } from "@/models/userProfile";
import { getUserProfile } from "@/services/userProfileAdminService";
import { genericError } from "@/modules/utilities";
import PInputField from "@/components/custom/PInputField.vue";
import { useSnackBarStore } from "@/stores/snackBarStore";

const snackbarStore = useSnackBarStore();

const email = ref("");
const showUserSearch = ref(true);
const userProfile = ref(new UserProfile());

async function checkUserExists(): Promise<void> {
  if (email.value.length > 0) {
    try {
      userProfile.value = await getUserProfile(email.value);

      if (userProfile.value.email == undefined) {
        snackbarStore.showError("User was not found");
      } else {
        showUserSearch.value = false;
      }
    } catch (error) {
      snackbarStore.showError(genericError);
    }
  }
}

function resetForm(): void {
  showUserSearch.value = true;
  email.value = "";
}
</script>
